import React, { useContext } from "react";
import GameRoomContext from "../../context/GameRoomContext";
import UserContext  from "../../context/UserContext";
import SocketContext from "../../context/SocketContext";
import { currentClientId, pidOf } from "../../utils/normalizePlayerId";


function GameRoomSpectators({ isConfigVisible = false, onParticipantSelect }) {

  const { gameRoomData, onBecomePlayer, onBecomeSpectator } = useContext(GameRoomContext);
  const { user } = useContext(UserContext);
  const socket = useContext(SocketContext);

  const gameRoomSpectators = gameRoomData?.gameRoomSpectators || [];
  const gameRoomPlayers = gameRoomData?.gameRoomPlayers || [];
  const voiceChatUsers = gameRoomData?.voiceChatUsers || [];
  const speakingUsers = gameRoomData?.speakingUsers || [];
  const maxPlayers = gameRoomData?.gameRoomConfigSchema?.maxPlayers ?? Infinity;
  const allowSpectators = gameRoomData?.gameRoomDetails?.allowSpectators !== false;
  const roomId = gameRoomData?.gameRoomDetails?.roomId;
  const myId = currentClientId(socket, user);
  const isSpectator = gameRoomSpectators.some((spectator) => pidOf(spectator) === myId);
  const canBecomePlayer = isConfigVisible && gameRoomPlayers.length < maxPlayers;
  const canBecomeSpectator = isConfigVisible && allowSpectators;


  return (
    <div className="w-full px-2">
      {isConfigVisible && (
        
          
          <button
            type="button"
            className={`mb-3 shrink-0 rounded px-3 py-1.5 font-semibold text-white ${isSpectator ? "bg-green-600 hover:bg-green-700 disabled:bg-green-400" : "bg-slate-700 hover:bg-slate-800 disabled:bg-slate-500"} disabled:cursor-not-allowed`}
            onClick={() => {
              if (isSpectator) {
                onBecomePlayer && onBecomePlayer(roomId);
              } else {
                onBecomeSpectator && onBecomeSpectator(roomId);
              }
            }}
            disabled={isSpectator ? !canBecomePlayer : !canBecomeSpectator}
            title={isSpectator
              ? (canBecomePlayer ? "Join as player" : "No player seats are available right now.")
              : (canBecomeSpectator ? "Move to spectators" : "Spectators are disabled for this room.")}
          >
            {isSpectator ? "Become a Player" : "Become a Spectator"}
          </button>
        
      )}
      
      <div className="flex flex-col gap-1">
        {gameRoomSpectators && gameRoomSpectators.length > 0 ? (
          gameRoomSpectators.map((s) => (
            <button
              type="button"
              key={s.userId || s.socketId || s.id}
              onClick={() => {
                if (typeof onParticipantSelect === "function") {
                  onParticipantSelect({ ...s, role: "spectator" });
                }
              }}
              className="flex w-full items-center gap-2 rounded-md border border-gray-200 bg-gray-50 p-1 text-left shadow-sm transition hover:border-blue-300 hover:bg-blue-50/60 dark:border-gray-700 dark:bg-gray-800 dark:hover:border-blue-700 dark:hover:bg-blue-950/40"
            >
              <span
                className="w-8 h-8 flex items-center justify-center text-xl font-bold rounded-full border"
                style={{ backgroundColor: s.color, borderColor: s.color }}
              >
                {s.icon || "👀"}
              </span>
              <span className="font-semibold text-gray-800 dark:text-gray-100 text-sm">
                {s.username}
                {user && (s.userId === user.userId || s.id === user.userId || s.socketId === user.userId) && ' (You)'}
              </span>
              {s.queuedForNextRound && (
                <span className="text-[11px] px-2 py-0.5 rounded-full bg-green-100 text-green-700 dark:bg-green-900/50 dark:text-green-200">
                  Next Round
                </span>
              )}
              {voiceChatUsers.includes(s.userId || s.socketId || s.id) && (
                <span title="In voice chat" className="ml-1">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill={speakingUsers.includes(s.userId || s.socketId || s.id) ? "#22c55e" : "#888"}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 3a4 4 0 0 1 4 4v4a4 4 0 0 1-8 0V7a4 4 0 0 1 4-4zm6 8a6 6 0 1 1-12 0" />
                    <path
                      d="M19 15v2a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-2"
                      stroke="#888"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </span>
              )}
            </button>
          ))
        ) : (
          <div className="text-xs text-gray-500">No spectators yet</div>
        )}
      </div>
    </div>
  );
}

export default GameRoomSpectators;
